import { AlertCircle, AlertTriangle, BadgeInfo, Check } from 'lucide-react';
import { Toaster as Sonner } from 'sonner';

import { useTheme } from '../../services/state/theme-state.jsx';

const Toaster = ({ ...props }) => {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group p-4 toast group-[.toaster]:bg-background group-[.toaster]:gap-3 group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg border border-muted-foreground/35',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      icons={{
        success: <Check className="size-5 text-success" />,
        info: <BadgeInfo className="size-5 text-corporate" />,
        warning: <AlertCircle className="size-5 text-yellow-500" />,
        error: <AlertTriangle className="size-5 text-destructive" />,
      }}
      {...props}
    />
  );
};

export { Toaster };
